import React, { Component } from "react";

import mixpanel from "../../lib/mixPanel";

export default class OurStory extends Component {
  render() {
    const { onCloseSection } = this.props;
    return (
      <div>
        {/* Header */}
        <div className="head-general with-back visible-xs">
          <a
            href="javascript: void(0)"
            onClick={() => onCloseSection("ourStory")}
            className="back"
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Our Story</h4>
          <a href="javascript: void(0)" className="close" />
        </div>
        {/* Header */}

        <div className="static our-story container">
          <div className="white-bg">
            <div className="img">
              <img
                src="/png/about.jpg"
                alt="About Us"
                srcSet="/png/about@2x.jpg 2x"
              />
            </div>
            <div className="desc">
              <div className="d-flex justify-content-between item item1">
                <div className="text">
                  <h5>ABOUT US</h5>
                  <p>
                    Local E was created with a mission to help the best local
                    independent restaurants and takeaways stand out and compete
                    in a world of high street mega chains and online corporate
                    giants, whilst digitally rewarding you along the way for
                    your loyalty. Find your favourite independently owned
                    takeaway spots or discover new hidden food gems on Local E’s
                    digital platform and get ready for a truly rewarding food
                    experience, whether it be delivered to your door or
                    collected in store.
                  </p>
                </div>
                <div className="flex-grow-1">
                  <img src="/svg/about-1.svg" />
                </div>
              </div>
              {/* /.d-flex */}

              <div className="d-flex justify-content-between item item2">
                <div className="flex-grow-1">
                  <img src="/png/about-2@2x.png" />
                </div>
                <div className="text">
                  <h5>OUR LITTLE BIT FOR AN INDEPENDENTLY OWNED HIGH STREET</h5>
                  <p>
                    You may not know it, but local independent restaurants need
                    your help! Whether it be unfair business rates, sky-high
                    commissions charged by online food portals (up to 35%!) or
                    the rise of corporate factory-style takeaway kitchens, your
                    local restaurants are battling an obstacle course of
                    problems which Local E are trying to solve. Our team are
                    passionate about food and small businesses, and with your
                    help we can keep a vibrant, independently owned high street
                    and food community open for business.{" "}
                  </p>
                </div>
              </div>
              {/* /.d-flex */}

              <div className="d-flex justify-content-between item item3">
                <div className="text">
                  <h5>LOYALTY MADE EASY</h5>
                  <p>
                    Redeeming rewards can be difficult to say the least...
                    Whether it involves logging on to another website and
                    filling out meaningless forms or just not being offered what
                    you really want. Here at Local E we’ve made it easier than
                    ever to earn and spend your loyalty eCoins online. Simply
                    gain eCoins on every order, store them in your wallet and
                    spend them like cash at any of our partner restaurants. A
                    tasty proposition.
                  </p>
                </div>
                <div className="flex-grow-1">
                  <img src="/png/about-3@2x.png" />
                </div>
              </div>
              {/* /.d-flex */}

              {/*
              <h5>MORE TO COME…</h5>
              <p>
                Rewarding customers to help out their local independent food
                heroes, what a noble idea you may say… so we thought why stop
                there? Our superstar developers are busy working their magic to
                bring you something entirely new (but slightly familiar!) later
                in 2019. So, keep your eyes peeled for an even more rewarding
                experience from Local E.
              </p>
              */}
            </div>
          </div>
          <div className="buttons">
            <div className="d-flex justify-content-around align-items-center">
              <a
                href="/privacy"
                onClick={() => mixpanel.track("Privacy Click")}
              >
                Privacy Policy
              </a>
              <span />
              <a href="/terms" onClick={() => mixpanel.track("Terms Click")}>
                Terms and Conditions
              </a>
            </div>
          </div>
          {/* .buttons */}
          <p className="small-label">Find out more at www.mylocale.co.uk</p>
        </div>
        {/* .static */}
      </div>
    );
  }
}
